module.exports = __webpack_public_path__ + "img/primary_4x3.54cda557.svg";